document.addEventListener('click', function (event) {
  var pill = event.target.closest('.pcard-size-pill');
  if (!pill || pill.disabled) return;

  var card = pill.closest('.product-card');
  if (!card) return;

  var swatchWrapper = pill.closest('[data-pcard-size-swatch]');
  if (swatchWrapper) {
    swatchWrapper.querySelectorAll('.pcard-size-pill').forEach(function (btn) {
      btn.classList.remove('is-selected');
      btn.setAttribute('aria-pressed', 'false');
    });
  }
  pill.classList.add('is-selected');
  pill.setAttribute('aria-pressed', 'true');

  var variantId = pill.getAttribute('data-variant-id');
  var price = pill.getAttribute('data-price');
  var comparePrice = pill.getAttribute('data-compare-price');
  var onSale = pill.getAttribute('data-on-sale') === 'true';
  var available = pill.getAttribute('data-available') === 'true';

  // Update price display
  var priceWrapper = card.querySelector('.f-price');
  if (priceWrapper) {
    var regularItem = priceWrapper.querySelector('.f-price__regular .f-price-item--regular');
    var saleItem = priceWrapper.querySelector('.f-price__sale .f-price-item--sale');
    var saleCompareItem = priceWrapper.querySelector('.f-price__sale .f-price-item--regular s');

    if (onSale) {
      priceWrapper.classList.add('f-price--on-sale');
      if (saleItem) saleItem.textContent = price;
      if (saleCompareItem) saleCompareItem.textContent = comparePrice;
    } else {
      priceWrapper.classList.remove('f-price--on-sale');
      if (regularItem) regularItem.textContent = price;
      if (saleItem) saleItem.textContent = price;
    }

    if (available) {
      priceWrapper.classList.remove('f-price--sold-out');
    } else {
      priceWrapper.classList.add('f-price--sold-out');
    }
  }

  // Update the add-to-cart form's hidden variant input
  var variantInput = card.querySelector('.product-variant-id');
  if (variantInput) {
    variantInput.value = variantId;
    if (available) {
      variantInput.removeAttribute('disabled');
    } else {
      variantInput.setAttribute('disabled', 'disabled');
    }
  }

  // Update the add-to-cart button's disabled state and label
  var atcButton = card.querySelector('.product-card__atc[type="submit"]');
  var atcText = card.querySelector('.product-card__action-text');
  if (atcButton) {
    if (available) {
      atcButton.removeAttribute('disabled');
    } else {
      atcButton.setAttribute('disabled', 'disabled');
    }
  }
  if (atcText) {
    var addLabel = atcText.getAttribute('data-add-to-cart-label');
    var soldOutLabel = atcText.getAttribute('data-sold-out-label');
    if (addLabel && soldOutLabel) {
      atcText.textContent = available ? addLabel : soldOutLabel;
    }
  }

  // Carry the selected variant through to the product page link
  card.querySelectorAll('[data-pcard-link]').forEach(function (link) {
    var baseHref = link.getAttribute('data-base-href');
    if (!baseHref) return;
    try {
      var url = new URL(baseHref, window.location.origin);
      url.searchParams.set('variant', variantId);
      link.setAttribute('href', url.pathname + url.search);
    } catch (e) {
      // silently ignore malformed URLs
    }
  });
});